import * as tslib_1 from "tslib";
import { EventEmitter, ViewContainerRef } from '@angular/core';
import { InputConverter } from '../../../inputConverter';
import { BaseComponent } from '../../base.component';
export var TabConverter = function (value) {
    if (typeof value === 'string') {
        return JSON.parse(value);
    }
    return value;
};
export var TabArrayConverter = function (value) {
    if (typeof value === 'string') {
        return JSON.parse(value);
    }
    return value;
};
// TODO: Remove this. Applications should do tabs on their own.
var TabsComponent = /** @class */ (function (_super) {
    tslib_1.__extends(TabsComponent, _super);
    function TabsComponent(_vcr) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.tabChanged = new EventEmitter();
        _this.activateTab = function (tab) {
            if (typeof tab === 'string') {
                tab = _this.tabs.find(function (t) { return t.name === tab; });
            }
            var pt = tab;
            if (pt && _this.activeTab.name !== pt.name) {
                _this.tabs.forEach(function (t) {
                    if (t.name !== pt.name) {
                        t.active = false;
                    }
                    else {
                        t.active = true;
                    }
                });
                _this.tabChanged.emit(_this.activeTab);
            }
        };
        _this.registerEvent('tabchanged', _this.tabChanged);
        return _this;
    }
    Object.defineProperty(TabsComponent.prototype, "includeGoogleAnalytics", {
        get: function () { return false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TabsComponent.prototype, "activeTab", {
        get: function () { return this.tabs.find(function (t) { return t.active; }); },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        InputConverter(TabArrayConverter),
        tslib_1.__metadata("design:type", Array)
    ], TabsComponent.prototype, "tabs", void 0);
    return TabsComponent;
}(BaseComponent));
export { TabsComponent };
